//
// Search widget
// -------------

define(function(require) {
    'use strict';

    var $ = require('j');
    var _ = require('underscore');
    var tmpl = require('tmpl');
    var device = require('util/device.util');

    require('common/jbone.widget');

    return $.widget('dropdown', {
        options: {
            source: {
                data: []
            },
            labelField: 'name',
            template: 'dropdown.widget'
        },

        defaultState: {
            isShowOverlay: device.formFactor !== 'desktop'
        },

        init: function(options) {
            _.extend(this.options, options);

            _.extend(this, this.defaultState, {
                isActive: false,
                lastItemIndex: 0,
                $window: $(window),
                $application: $('#application'),
                $portletWrapper: $(this.el.closest('.fn-portlet-wrapper'))
            });

            this.renderList();

            if (this.options.activeItem) {
                this.$el.find('.dropdown__display').html(this.options.activeItem[this.options.labelField]);
            }
            this.on(this.$el, {
                'tap .fn-dropdown-expand': this.handleActivateTap,
                'tap .fn-dropdown-item': this.handleItemTap,
            }, this);

            $(window).on('popstate.dropdown', this.deactivateDropdown.bind(this));
        },

        destroy: function() {
            return $.Widget.prototype.destroy.call(this);
        },

        handleActivateTap: function() {
            if (this.isActive) {
                this.deactivateDropdown();
                return;
            }

            this.isActive = true;
            this.$el.addClass('active');

            this.on(this.$application, {'tap': this.handleApplicationTap}, this);
        },

        deactivateDropdown: function() {
            if (!this.isActive) {
                return;
            }

            this.isActive = false;
            this.$el.removeClass('active');
            this.off(this.$application);
            this.off(this.$window);
        },

        /**
         * Remove class 'active' from wrapper
         * and reset result
         */
        handleApplicationTap: function(event) {
            if (!this.el.contains(event.target)) {
                this.deactivateDropdown();
            }
        },

        /**
         * Render list
         */
        renderList: function() {
            if (this.options.source.data.length > 0) {

                this.$el.append(tmpl[this.options.template](this.options));
            }
        },

        /**
         * Tap handler
         * @param  {Event} event
         */
        handleItemTap: function(event) {
            const selectedProvider = this.options.source.data[event.currentTarget.dataset.index];
            if (selectedProvider) {
                this.$el.find('.dropdown__display').html(selectedProvider[this.options.labelField]);
                this.$el.trigger($.Event('dropdown:changed', {
                    category: selectedProvider[this.options.labelField]
                }));
            }
            this.deactivateDropdown();
        }
    });
});
